import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Spinner, Center } from "@chakra-ui/react";
import { getUserInfo, ClientPrincipal, AUTHORIZED_EMAIL } from "../authConfig";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [user, setUser] = useState<ClientPrincipal | null>(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const fetchUser = async () => {
      const userInfo = await getUserInfo();
      // Only set user if authorized
      if (userInfo && userInfo.userDetails === AUTHORIZED_EMAIL) {
        setUser(userInfo);
      }
      setLoading(false);
    };
    fetchUser();
  }, []);

  if (loading) {
    return (
      <Center h="200px">
        <Spinner size="lg" color="teal.500" />
      </Center>
    );
  }

  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
